import { useMemo, useState } from 'react';

import { ReactComponent as CloseIcon } from '../../icons/close.svg';
import { ReactComponent as ImageIcon } from '../../icons/image.svg';

import './icon-chooser.scss';

import { Input } from '../common/input/Input';
import { SearchInput } from '../common/search-input/SearchInput';

export const IconChooser = ({
  icons,
  label,
  name,
  value,
  onChange,
  required,
  filled = true,
  bordered,
  style,
  error,
  display = false,
  props = {}
}) => {
  const [searchInput, setSearchInput] = useState(null);

  const fileName = useMemo(() => {
    try {
      const decodedUrl = decodeURIComponent(value);
      const fileName = decodedUrl.split('/').pop();
      const baseName = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;

      const words = baseName
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

      return words.join(' ');
    } catch (e) {
      return value;
    }
  }, [value]);

  const filteredIcons = useMemo(() => {
    return icons.filter((url) => {
      if (!searchInput) return true;

      try {
        const decodedUrl = decodeURIComponent(url);
        const fileName = decodedUrl.split('/').pop();
        const nameWithoutExt = fileName.split('.').slice(0, -1).join('.');
        return nameWithoutExt.toLowerCase().includes(searchInput.toLowerCase());
      } catch (e) {
        return false; // skip if decoding fails
      }
    });
  }, [icons, searchInput]);

  return (
    <div className="icon-chooser">
      <div>
        {label && (
          <label htmlFor={name}>
            {label}
            {required && !display ? <span> *</span> : ''}
          </label>
        )}
        <div>
          {value ? <img src={value} alt={name} /> : <ImageIcon />}
          <Input
            value={fileName}
            required={required}
            name={name}
            display
            placeholder="Choose an icon"
            filled={filled}
            bordered={bordered}
            style={style}
            clearIcon={!display && CloseIcon}
            error={error}
            props={props}
            onChange={onChange}
          />
        </div>
      </div>
      {!display && (
        <div>
          <span>Icon Picker</span>
          <div>
            <SearchInput
              onChange={(item) => setSearchInput(item.value)}
              value={searchInput}
              placeholder="Search"
            />
            <span>All Icons</span>
            <div>
              {filteredIcons.map((icon) => (
                <img
                  className={icon === value ? 'icon-chooser__selected' : ''}
                  src={icon}
                  alt={icon}
                  onClick={() => onChange({ name, value: icon })}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
